// Library Imports
import { createSlice } from '@reduxjs/toolkit';

// Initial State
const initialState = {
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
};

// Internet Connection Slice
const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    setConnectionStatus: (state, action) => {
      state.isOnline = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setConnectionStatus } = connectionSlice.actions;

export default connectionSlice.reducer;
